module.exports = __webpack_public_path__ + "img/Brownfield project.60a7303b.png";